import React from "react";
import { Button, Callout, Classes, Dialog, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { showToast } from "../../../../services/ToasterService";
import styles from "./SyncSchedulePanel.module.scss";

interface IErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string;
  errorDetails: string;
}

const ErrorDialog: React.FC<IErrorDialogProps> = ({
  isOpen,
  onClose,
  errorMessage,
  errorDetails
}) => {
  const handleCopyErrorDetails = () => {
    navigator.clipboard.writeText(errorDetails).then(() => {
      showToast("Error details copied to clipboard", Intent.SUCCESS);
    }).catch(() => {
      showToast("Failed to copy to clipboard", Intent.WARNING);
    });
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Save Failed"
      icon={IconNames.ERROR}
      style={{ width: '500px' }}
    >
      <div className={Classes.DIALOG_BODY}>
        <Callout intent={Intent.DANGER} icon={IconNames.ERROR}>
          <div className={styles.errorDialogBody}>
            <strong>{errorMessage}</strong>
          </div>
          <div className={styles.errorDialogMessage}>
            Your changes have been preserved. You can try saving again after resolving the issue.
          </div>
        </Callout>
        <div className={styles.errorDialogTechnical}>
          <div className={styles.errorDialogTechnicalTitle}>Technical Details:</div>
          <div className={styles.errorDialogTechnicalDetails}>
            {errorDetails}
          </div>
        </div>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            onClick={handleCopyErrorDetails}
            icon={IconNames.DUPLICATE}
            minimal
          >
            Copy Details
          </Button>
          <Button
            intent={Intent.PRIMARY}
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ErrorDialog;
